import { NextRouter } from 'next/router';
import { MegaMenu, MegaMenuEntry, LinkedCollection } from '@monofront/types';

const findCollectionByHandle = (
  collections: MegaMenuEntry[],
  handle: string,
): LinkedCollection | null => {
  for (const collection of collections) {
    // 1. Direct match
    if (collection.linkedCollection.handle === handle) {
      return collection.linkedCollection;
    }

    // 2. Search in children
    const childMatch = findCollectionByHandle(
      collection.subCollections,
      handle,
    );

    if (childMatch) {
      return childMatch;
    }
  }

  return null;
};

const getTitleFromCollection = (
  megamenu: MegaMenu,
  handle: string,
): string | null => {
  if (!handle) {
    return null;
  }

  const collection = findCollectionByHandle(megamenu.collections, handle);

  return collection?.title ?? null;
};

export const getMobileTitle = (
  megamenu: MegaMenu,
  props: any,
  router: NextRouter,
  customTitleHeaderMobile: string | null,
): string | null => {
  // funnel page
  if (props?.mobileHeaderTitle) {
    return props.mobileHeaderTitle;
  }

  // Prismic Page
  if (props?.mobileTitle) {
    return props.mobileTitle;
  }

  // Product page
  if (props?.product) {
    return props.product.title;
  }

  // Page collection which is in the menu
  if (router.query.handle) {
    const handle = router.query.handle as string;

    return getTitleFromCollection(megamenu, handle);
  }

  // Pages with custom title
  if (customTitleHeaderMobile) {
    return customTitleHeaderMobile;
  }

  return null;
};
